import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import type { OrderStatus } from '@/types/enums'
import { isStatusBadgeMutedVariant } from '@/utils/statusColors'

export function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation()
  const muted = isStatusBadgeMutedVariant(status)
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-[var(--stryzh-radius-pill)] px-[var(--stryzh-space-4)] py-1',
        'font-[family-name:var(--stryzh-font-family-mono)] text-[length:var(--stryzh-font-size-xs)] font-bold uppercase',
        'tracking-[var(--stryzh-letter-spacing-mono-badge)]',
        muted
          ? 'border border-[color:var(--stryzh-color-status-badge-muted-border)] bg-[color:var(--stryzh-color-status-badge-muted-bg)] text-[color:var(--stryzh-color-status-badge-muted-text)]'
          : 'border border-[color:var(--stryzh-color-status-badge-accent-border)] bg-[color:var(--stryzh-color-status-badge-accent-bg)] text-[color:var(--stryzh-color-status-badge-accent-text)]',
      )}
    >
      {t(`orderStatus.${status}`)}
    </span>
  )
}
